import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import api from '@/utils/api';
import { claimPushSubscription } from '@/utils/pushNotifications';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('sushi_token'));
  const [loading, setLoading] = useState(true);

  const fetchProfile = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const { data } = await api.get('/auth/perfil');
      setUser(data.usuario);
      // Claim anonymous push subscriptions after login
      claimPushSubscription().catch(() => {});
    } catch {
      localStorage.removeItem('sushi_token');
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  const login = async (email, password) => {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('sushi_token', data.token);
    setToken(data.token);
    setUser(data.usuario);
    claimPushSubscription().catch(() => {});
    return data;
  };

  const registro = async (fields) => {
    const { data } = await api.post('/auth/registro', fields);
    localStorage.setItem('sushi_token', data.token);
    setToken(data.token);
    setUser(data.usuario);
    claimPushSubscription().catch(() => {});
    return data;
  };

  const logout = () => {
    localStorage.removeItem('sushi_token');
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, registro, logout, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
